import React from "react";
import { useSelector } from "react-redux";
import { Redirect, Route, RouteComponentProps, Switch } from "react-router-dom";
import useFlash from "go-alert/AlertMessage";
import Page404 from "go-app/components/Page404/Page404";
import { SegmentContext, SegmentListService } from "go-segment/context";
import { partnerApiSegment } from "../../../../services/Api/Partner/partnerApiSegment";
import { supportApiSegment } from "../../../../services/Api/Support/supportApiSegment";
import { hasRole, selectIsAdmin } from "../../../../services/users/selectors";
import SupportNavigation from "./components/SupportNavigation";
import SupportOrganizationsPage from "./pages/Organizations";
import SupportSearchOrganizationPage from "./pages/SearchOrganization/pages";
import SupportActionsPage from "./pages/SupportActions";

const SupportPage = (props: RouteComponentProps) => {
	const segmentPath = `/admin/segments`;
	const { addFlash } = useFlash();
	const isAdmin = useSelector(selectIsAdmin);
	const hasSupportRole = useSelector(hasRole("SUPPORT"));
	const isActionsRouteAccessible = isAdmin || hasSupportRole;

	return (
		<SegmentContext.Provider
			value={
				new SegmentListService(
					{
						saveSegment: partnerApiSegment.saveSegment,
						removeSegment: partnerApiSegment.removeSegment,
						getSegments: partnerApiSegment.getSegments,
						restoreSegment: partnerApiSegment.restoreSegment,
						updateSegment: partnerApiSegment.updateSegment,
						updateSegments: partnerApiSegment.updateSegments,
						setAsDefault: partnerApiSegment.setSegmentAsDefault,
						setNotDefault: partnerApiSegment.setSegmentNotDefault,
					},
					segmentPath,
					supportApiSegment.getListInfo,
					addFlash
				)
			}
		>
			<div className="page-container">
				<SupportNavigation />
				<Switch>
					<Route path={`${props.match.url}/organizations_with_access`} component={SupportOrganizationsPage} />
					<Route path={`${props.match.url}/search_organization`} component={SupportSearchOrganizationPage} />
					{isActionsRouteAccessible && (
						<Route path={`${props.match.url}/actions`} component={SupportActionsPage} />
					)}
					<Redirect from={`${props.match.url}`} to={`${props.match.url}/organizations_with_access`} />
					<Route component={Page404} />
				</Switch>
			</div>
		</SegmentContext.Provider>
	);
};

export default SupportPage;
